import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, List, FileText, Users, Search, Clock } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const [rippleEffect, setRippleEffect] = useState(null);

  const navItems = [
    { path: '/', icon: BookOpen, label: 'Ana Sayfa' },
    { path: '/sureler', icon: List, label: 'Sureler' },
    { path: '/namaz-vakitleri', icon: Clock, label: 'Namaz' },
    { path: '/hafizlar', icon: Users, label: 'Hafızlar' },
    { type: 'search', icon: Search, label: 'Ara' }
  ];

  const handleRipple = (index) => {
    setRippleEffect(index);
    setTimeout(() => setRippleEffect(null), 600);
  };

  const handleSearchClick = () => {
    window.dispatchEvent(new Event('openSearch'));
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 w-full max-w-full overflow-hidden">
      {/* Gradient overlay for depth */}
      <div className="absolute inset-x-0 bottom-full h-12 bg-gradient-to-t from-black/5 to-transparent pointer-events-none" />
      
      <div className="bg-[#F5EFE7]/98 backdrop-blur-xl border-t-2 border-[#D5C4A1] shadow-2xl w-full">
        <div className="grid grid-cols-5 h-16 relative w-full max-w-full">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          const isSearch = item.type === 'search';
          
          // Search button (same style as others)
          if (isSearch) {
            return (
              <button
                key="search"
                onClick={() => {
                  handleRipple(index);
                  handleSearchClick();
                }}
                className="flex flex-col items-center justify-center relative group"
              >
                {/* Active indicator - animated line */}
                <div 
                  className="absolute top-0 left-1/2 -translate-x-1/2 transition-all duration-500 ease-out h-0 w-0"
                />
                
                {/* Icon container with advanced animation */}
                <div className="flex flex-col items-center justify-center transition-all duration-300 scale-100 group-active:scale-95">
                  <div className="p-2 rounded-2xl transition-all duration-300 relative overflow-hidden bg-transparent group-active:bg-[#E8DCC8]">
                    <Icon className="h-5 w-5 text-[#6B5744] group-active:text-[#8B7355] transition-all duration-300 relative z-10" />
                  </div>
                  
                  {/* Label with bounce */}
                  <span className="text-[10px] mt-1 font-medium text-[#6B5744] group-active:text-[#8B7355] transition-all duration-300">
                    {item.label}
                  </span>
                </div>

                {/* Background glow on active */}
                <div className="absolute inset-0 transition-all duration-500 opacity-0 scale-100" />
                
                {/* Ripple effect */}
                {rippleEffect === index && (
                  <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute inset-0 bg-[#8B7355]/20 rounded-full animate-ping" />
                  </div>
                )}
              </button>
            );
          }
          
          // Regular navigation items
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => handleRipple(index)}
              className="flex flex-col items-center justify-center relative group"
            >
              {/* Active indicator - animated line */}
              <div 
                className={`absolute top-0 left-1/2 -translate-x-1/2 transition-all duration-500 ease-out ${
                  isActive 
                    ? 'h-1 w-10 bg-gradient-to-r from-[#8B7355] to-[#D5C4A1] rounded-b-full' 
                    : 'h-0 w-0'
                }`}
              />
              
              {/* Icon container with advanced animation */}
              <div 
                className={`flex flex-col items-center justify-center transition-all duration-300 ${
                  isActive ? 'scale-110 -translate-y-1' : 'scale-100 group-active:scale-95'
                }`}
              >
                <div 
                  className={`p-2 rounded-2xl transition-all duration-300 relative overflow-hidden ${
                    isActive 
                      ? 'bg-[#8B7355] shadow-lg shadow-[#8B7355]/30' 
                      : 'bg-transparent group-active:bg-[#E8DCC8]'
                  }`}
                >
                  {/* Shimmer effect on active */}
                  {isActive && (
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" />
                  )}
                  
                  <Icon 
                    className={`transition-all duration-300 relative z-10 ${
                      isActive 
                        ? 'h-6 w-6 text-white' 
                        : 'h-5 w-5 text-[#6B5744] group-active:text-[#8B7355]'
                    }`}
                  />
                </div>
                
                {/* Label with bounce */}
                <span 
                  className={`text-[10px] mt-1 font-medium transition-all duration-300 ${
                    isActive 
                      ? 'text-[#8B7355] font-bold scale-105' 
                      : 'text-[#6B5744] group-active:text-[#8B7355]'
                  }`}
                >
                  {item.label}
                </span>
              </div>

              {/* Background glow on active */}
              <div 
                className={`absolute inset-0 transition-all duration-500 ${
                  isActive ? 'bg-[#8B7355]/5 scale-110' : 'opacity-0 scale-100'
                }`}
              />
              
              {/* Ripple effect */}
              {rippleEffect === index && (
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute inset-0 bg-[#8B7355]/20 rounded-full animate-ping" />
                </div>
              )}
            </Link>
          );
        })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
